'use client'
import React from 'react'
import styles from './stylers.module.scss'

interface InputCheckboxProps {
  label: string
  id: string
  type?: 'checkbox'
  onChangeHandler?: (value: any) => void
  onChange?: (event: React.ChangeEvent | any) => void
  withBorder?: boolean
  checked?: boolean
  isActive?: boolean
  onClick?: (e?: any) => void
}

const InputCheckbox: React.FC<InputCheckboxProps> = ({
  label,
  id,
  onChangeHandler,
  type = 'checkbox',
  onChange = () => {},
  withBorder,
  isActive,
  onClick,
  ...props
}) => {
  return (
    <div>
      <label
        className={`${styles.label} ${withBorder ? styles.withBorder : ''} ${
          isActive ? styles.active : ''
        }`}
        htmlFor={id}
        onClick={e => {
          if (!onClick) return
          e.preventDefault()
          onClick?.()
        }}
      >
        {label}
        <input
          id={id}
          type={type}
          {...props}
          onChange={onChangeHandler || onChange}
        />
        <span />
      </label>
    </div>
  )
}

export default InputCheckbox
